/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react";

import Button from "ui/kit/buttons/Button";
import ReprocessPiece from "mutation/ReprocessPiece";

interface Props {
    pieceId: string;
}

const PieceSettingsReprocessItem: React.FC<Props> = ({pieceId}) => {

    const onReprocess = React.useCallback(async () => {
        await ReprocessPiece(pieceId);
        alert("Reprocess started");
    }, [pieceId]);

    return (
        <div>
            <Button onClick={onReprocess} title={"Start Reprocess"}/>
        </div>
    );
}

export default PieceSettingsReprocessItem;